export default "__VITE_ASSET__CSnNviQb__"